'use client';

import { useEffect } from 'react';
import { AppVersionService } from '@/services/app-version.service';
import { useAppReleaseStore } from '@/stores/app-release.store';
import { DEV_BUILD_NUMBER, getBuildNumber } from '@/lib/build-info';
import { logger } from '@/lib/logger';

const REFRESH_INTERVAL_MS = 60000;

const appVersionService = new AppVersionService();

export const useReleaseCheck = () => {
  const markStale = useAppReleaseStore((state) => state.markStale);
  const needsRefresh = useAppReleaseStore((state) => state.needsRefresh);

  useEffect(() => {
    if (needsRefresh) return;

    const currentBuild = getBuildNumber();
    if (currentBuild === DEV_BUILD_NUMBER) return;

    const currentNumeric = Number(currentBuild);

    let cancelled = false;

    const check = async () => {
      try {
        const { version } = await appVersionService.getDeployedVersion();
        if (cancelled) return;
        const remoteNumeric = Number(version);
        if (
          Number.isFinite(currentNumeric) &&
          Number.isFinite(remoteNumeric) &&
          remoteNumeric > currentNumeric
        ) {
          markStale();
        }
      } catch (error) {
        logger.warn('release check failed', {
          feature: 'release-check',
          route: 'poll',
          error,
        });
      }
    };

    check();
    const intervalId = window.setInterval(check, REFRESH_INTERVAL_MS);
    return () => {
      cancelled = true;
      window.clearInterval(intervalId);
    };
  }, [markStale, needsRefresh]);
};
